import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";

function Input1xbet({
  as,
  disabled,
  error,
  handleBlur,
  handleFocus,
  handleChange,
  id,
  label,
  options,
  placeholder,
  type,
  maxLength,
  value,
  autoFocus,
}) {
  return (
    <div className="flex flex-col w-full gap-1 p-5 items-start bg-mercago-light-cyan transition-colors">
      {label !== "none" && (
        <label
          htmlFor={id}
          className={`text-sm leading-tight ${
            error ? "text-red-500" : "text-dark-gray"
          }`}
        >
          {label || placeholder}
        </label>
      )}

      <div className="flex h-8 w-full items-center relative">
        <Field
          as={as}
          autoComplete="new-password"
          autoFocus={autoFocus}
          disabled={disabled}
          id={id}
          name={id}
          maxLength={maxLength}
          placeholder={placeholder}
          type={type}
          value={value}
          onBlur={() => handleBlur && handleBlur()}
          onFocus={() => handleFocus && handleFocus()}
          {...(handleChange ? { onChange: handleChange } : {})}
          className={`w-full bg-transparent border-none p-0 m-0 outline-none
            font-semibold text-black text-base leading-none
            placeholder:text-gray-400 placeholder:font-normal
            disabled:opacity-50 disabled:cursor-not-allowed
            [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none`}
        >
          {options?.length &&
            options.map(({ label: optionLabel, value: optionValue }) => (
              <option key={optionValue} value={optionValue}>
                {optionLabel}
              </option>
            ))}
        </Field>
      </div>

      {error && (
        <span className="text-[10px] text-red-500 mt-1 animate-fade-in">
          Campo requerido o inválido
        </span>
      )}
    </div>
  );
}

Input1xbet.propTypes = {
  as: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  handleBlur: PropTypes.func,
  handleFocus: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  autoFocus: PropTypes.bool,
};

export default Input1xbet;
